import React, { useEffect, useState } from 'react';

const ClinicSurvey = () => {
  
  const [step, setStep] = useState('intro'); // 'intro', 'questions', 'submitted'
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nurseCategory: "",
    nurseCategoryOther: "",
    durationAtPharmacy: "",
    rateSupport: "",
    addValue: "",
    addValueDetails: "",
    enrolledLocalEd: "",
    trainingTopics: "",
    commHO: "",
    commPlatform: "",
    storeIntegration: "",
    tlcFamily: "",
    roleSatisfaction: "",
    actionsTLC: "",
    topFrustration: "",
    newServices: "",
    recommendTLC: "", // 1-5 scale
    contactMe: "",
    userName: "",
    userSurname: "",
    userContact: "",
    userEmail: "",
  });

   useEffect(() => {
      console.log(formData)
  },[formData])
  
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
      try {
        
          setLoading(true);
          const payLoad = {
            ...formData,
            timestamp: new Date().toISOString()
          };

          const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbw79RPFKdSko7mGjkxJGTF-8JSze9twZQhvmzbPxvptwOvfVYPwls2bnZdS-vQYJER2/exec';
              
          const response = await fetch(SCRIPT_URL, {
                  method: 'POST',
                  mode: 'no-cors', // standard for Apps Script to avoid pre-flight issues
                  headers: {
                  'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formData),
              });
              
          setLoading(false);
         //add success message
         setStep('submitted');
      }catch(err){
         setLoading(false);
         //add error message
      }
  };

  // Reusable component for the 1-5 Scale buttons
  const ScaleRating = ({ field, label, lowLabel, highLabel }) => (
    <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
      <label className="block text-base font-semibold text-gray-900 mb-1.5">{label}</label>
      <p className="text-xs text-gray-400 mb-4">(1 = {lowLabel}, 5 = {highLabel})</p>
      
      {/* Grid structure ensures buttons scale nicely on mobile */}
      <div className="grid grid-cols-5 gap-2.5">
        {[1, 2, 3, 4, 5].map((num) => {
          const isSelected = formData[field] === num.toString();
          return (
            <button
              key={num}
              type="button"
              onClick={() => handleInputChange(field, num.toString())}
              className={`flex items-center justify-center aspect-square text-xl font-bold rounded-xl border-2 transition-all duration-150 active:scale-95 
              ${isSelected
                  ? 'bg-[#fef2f3] border-[#ce2030] text-[#ce2030] shadow-inner'
                  : 'bg-white border-gray-200 text-gray-500 hover:border-[#ce2030]/50'
                }`}
            >
              {num}
            </button>
          );
        })}
      </div>
      <div className="flex justify-between mt-3 text-[11px] text-gray-400 uppercase tracking-wider font-bold px-1">
        <span>{lowLabel}</span>
        <span>{highLabel}</span>
      </div>
    </div>
  );

  // Define options for ease of rendering
  const nursingCategories = ['Professional nurse', 'Enrolled nurse', 'Nursing assistant'];
  const tlcDurationOptions = ['Less than 1 year', '1 – 3 years', '4 – 7 years', '8 years or more'];
  const yesNoOptions = ['No', 'Yes'];
  const commPlatforms = ['WhatsApp', 'Email', 'Both (WhatsApp and Email)'];
  const contactOptions = [
    'Yes, contact me to discuss my feedback',
    'Yes, I would like to participate in future research',
    'No, I prefer not to be contacted'
  ];

  // --- View: Introduction ---
  if (step === 'intro') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-xl w-full bg-white rounded-3xl shadow-xl overflow-hidden border-t-[10px] border-[#ce2030]">
          <div className="p-8 md:p-10">
            <h1 className="text-2xl md:text-3xl font-extrabold text-gray-950 mb-5 tracking-tight">
              Welcome to the <br/><italic>Clinic survey</italic>
            </h1>
            <div className="prose prose-gray leading-relaxed text-gray-700 mb-8 space-y-4">
              <p>
                We’d love to hear your thoughts. Your feedback will help us better understand your experience and 
                will help improve the support, training and integration within The Local Choice network.
              </p>
              <p className="text-sm font-medium text-gray-500 bg-gray-100 p-4 rounded-xl border border-gray-200">
                Please complete the survey; it will take less than 10 minutes.
              </p>
            </div>
            <button 
              onClick={() => { setStep('questions'); window.scrollTo(0, 0); }}
              className="w-full bg-[#ce2030] hover:bg-[#a71a26] text-white font-bold text-lg py-4.5 rounded-2xl transition-all duration-150 shadow-lg shadow-[#ce2030]/20 active:scale-[0.98]"
            >
              Start survey
            </button>
          </div>
        </div>
      </div>
    );
  }

  // --- View: Submitted ---
  if (step === 'submitted') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-lg w-full bg-white p-10 md:p-12 rounded-3xl shadow-lg text-center border-t-[10px] border-[#ce2030]">
          <div className="w-20 h-20 bg-[#fef2f3] rounded-full flex items-center justify-center mx-auto mb-8 border-4 border-white shadow-md">
            <svg className="w-10 h-10 text-[#ce2030]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-3xl font-extrabold text-gray-950 mb-4 tracking-tight">Thank You</h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-md mx-auto">
            Thank you for taking the time to share your perspective, we really appreciate your input.
          </p>
        </div>
      </div>
    );
  }

  // --- View: Main Survey Form (Mobile First) ---
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 md:py-10">
      {/* Consistent container width for mobile/desktop readability */}
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-5 md:space-y-6">
        
        {/* Header/Progress indicator (Visual only) */}
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between">
          <span className="text-sm font-bold text-[#ce2030]">The Local Choice Clinic Survey</span>
          <span className="text-xs font-mono text-gray-400">Response Portal</span>
        </div>

        {/* Q1: Nursing Category (Radio List) */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-4">1. What is your nursing category?</label>
          <div className="space-y-3">
            {nursingCategories.map((option) => (
              <label key={option} className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-150 ${formData.nurseCategory === option ? 'border-[#ce2030] bg-[#fef2f3]' : 'border-gray-100 hover:border-gray-200'}`}>
                <input 
                  type="radio" 
                  name="nurseCategory" 
                  checked={formData.nurseCategory === option}
                  onChange={() => handleInputChange('nurseCategory', option)}
                  className="w-5 h-5 text-[#ce2030] focus:ring-[#ce2030] border-gray-300" 
                />
                <span className="ml-3.5 font-medium text-gray-800">{option}</span>
              </label>
            ))}
            {/* Other option logic */}
            <div className={`flex items-center p-4 border-2 rounded-xl ${formData.nurseCategory === 'Other' ? 'border-[#ce2030] bg-[#fef2f3]' : 'border-gray-100'}`}>
              <input 
                type="radio" 
                name="nurseCategory" 
                checked={formData.nurseCategory === 'Other'}
                onChange={() => handleInputChange('nurseCategory', 'Other')}
                className="w-5 h-5 text-[#ce2030] focus:ring-[#ce2030] border-gray-300" 
              />
              <input 
                type="text" 
                placeholder="Other category..." 
                value={formData.nurseCategoryOther}
                onChange={(e) => {
                  handleInputChange('nurseCategory', 'Other'); // Auto-select radio
                  handleInputChange('nurseCategoryOther', e.target.value);
                }}
                className="ml-3.5 w-full bg-transparent border-b border-gray-300 focus:border-[#ce2030] outline-none py-0.5 text-gray-800" 
              />
            </div>
          </div>
        </div>

        {/* Q2: Duration */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-4">2. How long have you been part of The Local Choice pharmacy?</label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {tlcDurationOptions.map((option) => (
              <label key={option} className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-150 ${formData.durationAtPharmacy === option ? 'border-[#ce2030] bg-[#fef2f3]' : 'border-gray-100 hover:border-gray-200'}`}>
                <input 
                  type="radio" 
                  name="durationAtPharmacy" 
                  checked={formData.durationAtPharmacy === option}
                  onChange={() => handleInputChange('durationAtPharmacy', option)}
                  className="w-5 h-5 text-[#ce2030] focus:ring-[#ce2030] border-gray-300" 
                />
                <span className="ml-3.5 font-medium text-gray-800">{option}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Q3: Support Rating */}
        <ScaleRating 
          field="rateSupport" 
          label="3. How would you rate the support you receive from your Clinic Advisor?" 
          lowLabel="Very poor" 
          highLabel="Excellent" 
        />

        {/* Q4a: Value Rating */}
        <ScaleRating 
          field="addValue" 
          label="4a. Does your Clinic Advisor add value to your clinic operations?" 
          lowLabel="No value at all" 
          highLabel="Significant value" 
        />

        {/* Q4b: Open Ended (Textarea) */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-3.5">4b. How does your Clinic Advisor add value, or what improvements would you suggest?</label>
          <textarea 
            rows="5" 
            value={formData.addValueDetails}
            onChange={(e) => handleInputChange('addValueDetails', e.target.value)}
            className="w-full border border-gray-200 rounded-xl p-4 text-gray-800 focus:ring-2 focus:ring-[#ce2030]/20 focus:border-[#ce2030] outline-none transition duration-150 resize-none"
            placeholder="Please provide specifics..."
          />
        </div>

        {/* Q5: Enrolled (Segmented Control style) */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-4">5. Have you enrolled in the LocalEd programme?</label>
          <div className="flex gap-3">
            {yesNoOptions.map((val) => (
              <button
                key={val}
                type="button"
                onClick={() => handleInputChange('enrolledLocalEd', val)}
                className={`flex-1 py-4 rounded-xl font-bold text-lg border-2 transition-all duration-150 ${
                  formData.enrolledLocalEd === val 
                    ? 'bg-[#ce2030] border-[#ce2030] text-white shadow-md' 
                    : 'bg-white border-gray-200 text-gray-500 hover:border-gray-300'
                }`}
              >
                {val}
              </button>
            ))}
          </div>
        </div>

        {/* Q6: Training Topics */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-3.5">6. What topics or types of training would you like to see added to the LocalEd programme?</label>
          <textarea 
            rows="5" 
            value={formData.trainingTopics}
            onChange={(e) => handleInputChange('trainingTopics', e.target.value)}
            className="w-full border border-gray-200 rounded-xl p-4 text-gray-800 focus:ring-2 focus:ring-[#ce2030]/20 focus:border-[#ce2030] outline-none transition duration-150 resize-none"
            placeholder="List topics or areas for improvement..."
          />
        </div>

        {/* Q7: HO Comm Rating */}
        <ScaleRating 
          field="commHO" 
          label="7. How sufficient do you find the communication from The Local Choice head office?" 
          lowLabel="Very insufficient" 
          highLabel="Very sufficient" 
        />

        {/* Q8: Comm Platform */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-4">8. Which communication platform do you prefer for updates from The Local Choice head office?</label>
          <div className="space-y-3">
            {commPlatforms.map((option) => (
              <label key={option} className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-150 ${formData.commPlatform === option ? 'border-[#ce2030] bg-[#fef2f3]' : 'border-gray-100 hover:border-gray-200'}`}>
                <input 
                  type="radio" 
                  name="commPlatform" 
                  checked={formData.commPlatform === option}
                  onChange={() => handleInputChange('commPlatform', option)}
                  className="w-5 h-5 text-[#ce2030] focus:ring-[#ce2030] border-gray-300" 
                />
                <span className="ml-3.5 font-medium text-gray-800">{option}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Q9: Store Integration */}
        <ScaleRating 
          field="storeIntegration" 
          label="9. How integrated do you feel with your store team?" 
          lowLabel="Completely disconnected" 
          highLabel="Fully integrated" 
        />

        {/* Q10: TLC Family */}
        <ScaleRating 
          field="tlcFamily" 
          label="10. How connected do you feel to The Local Choice ‘family’?" 
          lowLabel="Very disconnected" 
          highLabel="Very connected" 
        />

        {/* Q11: Role Satisfaction */}
        <ScaleRating 
          field="roleSatisfaction" 
          label="11. Thinking about the last 6 months, how satisfied are you with your clinic role within The Local Choice?" 
          lowLabel="Very dissatisfied" 
          highLabel="Very satisfied" 
        />

        {/* Q12: Support Actions */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-3.5">12. What specific actions can The Local Choice take to better support you in your clinic role?</label>
          <textarea 
            rows="5" 
            value={formData.actionsTLC}
            onChange={(e) => handleInputChange('actionsTLC', e.target.value)}
            className="w-full border border-gray-200 rounded-xl p-4 text-gray-800 focus:ring-2 focus:ring-[#ce2030]/20 focus:border-[#ce2030] outline-none transition duration-150 resize-none"
            placeholder="Specific examples help us improve..."
          />
        </div>

        {/* Q13: Pain Point */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-3.5">13. What is your top frustration or pain point in your day-to-day operations within the clinic?</label>
          <textarea 
            rows="5" 
            value={formData.topFrustration}
            onChange={(e) => handleInputChange('topFrustration', e.target.value)}
            className="w-full border border-gray-200 rounded-xl p-4 text-gray-800 focus:ring-2 focus:ring-[#ce2030]/20 focus:border-[#ce2030] outline-none transition duration-150 resize-none"
            placeholder="Describe your biggest challenge..."
          />
        </div>

        {/* Q14: New Services */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-3.5">14. What clinic services or products should The Local Choice consider to offer?</label>
          <textarea 
            rows="5" 
            value={formData.newServices}
            onChange={(e) => handleInputChange('newServices', e.target.value)}
            className="w-full border border-gray-200 rounded-xl p-4 text-gray-800 focus:ring-2 focus:ring-[#ce2030]/20 focus:border-[#ce2030] outline-none transition duration-150 resize-none"
            placeholder="Ideas for growth..."
          />
        </div>

        {/* Q15: NPS Reduced to 1-5 */}
        <ScaleRating 
          field="recommendTLC" 
          label="15. How likely are you to recommend The Local Choice franchise to a colleague?" 
          lowLabel="Not at all likely" 
          highLabel="Extremely likely" 
        />

        {/* Q16: Contact Follow-up */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100">
          <label className="block text-base font-semibold text-gray-900 mb-4">16. Would you like to be contacted about your feedback or participate in future research?</label>
          <div className="space-y-3">
            {contactOptions.map((option) => (
              <label key={option} className={`flex items-start p-4 border-2 rounded-xl cursor-pointer transition-all duration-150 ${formData.contactMe === option ? 'border-[#ce2030] bg-[#fef2f3]' : 'border-gray-100 hover:border-gray-200'}`}>
                <input 
                  type="radio" 
                  name="contactMe" 
                  checked={formData.contactMe === option}
                  onChange={() => handleInputChange('contactMe', option)}
                  className="w-5 h-5 mt-0.5 text-[#ce2030] focus:ring-[#ce2030] border-gray-300" 
                />
                <span className="ml-3.5 font-medium text-gray-800">{option}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Personal Details (Input Fields) */}
        <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100 space-y-4">
          <label className="block text-base font-semibold text-gray-900 border-b border-gray-100 pb-3">Please share your details below:</label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { field: 'userName', placeholder: 'Name' },
              { field: 'userSurname', placeholder: 'Surname' },
              { field: 'userContact', placeholder: 'Contact Number', type: 'tel' },
              { field: 'userEmail', placeholder: 'Email Address', type: 'email' },
            ].map(input => (
              <input 
                key={input.field}
                type={input.type || 'text'} 
                placeholder={input.placeholder} 
                value={formData[input.field]}
                onChange={(e) => handleInputChange(input.field, e.target.value)}
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#ce2030]/20 focus:border-[#ce2030] outline-none transition duration-150 text-gray-800"
              />
            ))}
          </div>
        </div>

        {/* Submit Button with Loading State */}
        <div className="pt-4 pb-8">
          <button 
            disabled={loading}
            type="submit"
            className="w-full bg-[#ce2030] text-white font-bold text-lg py-5 rounded-2xl shadow-lg shadow-[#ce2030]/20 hover:bg-[#a71a26] transition-all duration-150 disabled:bg-gray-300 disabled:shadow-none flex items-center justify-center active:scale-[0.98]"
          >
            {loading ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-3 text-white" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Submitting...
              </>
            ) : 'Submit Feedback'}
          </button>
        </div>
      </form>
    </div>
  );
};
  
export default ClinicSurvey;